define('helperContent-getEntity',[],function() {
    'use strict';

    var entities = entities || {},
        f = function(ID, arr) {
        var res, entity;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        arr = [].concat(arr);

        for (var i = 0; i < arr.length; i++) {
            entity = arr[i];

            if (entity.hasOwnProperty('contentEntityId') && entity.contentEntityId === ID) {
                return ((entity.hasOwnProperty('contentEntity') && entity.contentEntity && typeof entity.contentEntity === 'object' && Object.keys(entity.contentEntity).length !== 0)) ? entity : null;
            } else if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length) {
                res = f(ID, entity.children);
                if (res) {
                    return res;
                }
            }
        }

        return null;
    },
    getEntity = function(ID, arr) {
        var entity;

        if (!ID || !Array.isArray(arr)) {
            return null;
        }

        // if (entities[ID] !== undefined) {
        //     return entities[ID];
        // }

        entity = f(ID, arr);

        if (!entity) {
            entities[ID] = null;
        }

        return entity;
    };

    return getEntity;
});

